import { all } from "redux-saga/effects";
import { dotTaoDeSaga } from "./dotTaoDeSaga";
import { cauTrucDeThiSaga } from "./cauTrucDeThiSaga";
import { deThiSaga } from "./deThiSaga";
import { nhomDeThiInSaga } from "./de-thi-in/nhomDeThiInSaga";
import { chuDeThiInSaga } from "./de-thi-in/chuDeThiInSaga";
import { deThiInSaga } from "./de-thi-in/deThiInSaga";
import { phanPhoiDeThiSaga } from "./phanPhoiDeThiSaga";

export default function* deThiSagaWrapper() {
  yield all([
    dotTaoDeSaga(),
    cauTrucDeThiSaga(),
    deThiSaga(),
    nhomDeThiInSaga(),
    chuDeThiInSaga(),
    deThiInSaga(),
    phanPhoiDeThiSaga(),
  ]);
}
